import { AuthErrorCodes } from 'firebase/auth';

export const firebaseErrorTranslationKeysMap = new Map<string, string>([
  [AuthErrorCodes.EMAIL_EXISTS, 'AUTH.ERRORS.EMAIL_EXISTS'],
  [AuthErrorCodes.INVALID_LOGIN_CREDENTIALS, 'AUTH.ERRORS.INVALID_LOGIN_CREDENTIALS'],
  [AuthErrorCodes.NEED_CONFIRMATION, 'AUTH.ERRORS.NEED_CONFIRMATION'],
  [AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER, 'AUTH.ERRORS.TOO_MANY_ATTEMPTS_TRY_LATER'],
  [AuthErrorCodes.USER_CANCELLED, 'AUTH.ERRORS.USER_CANCELLED'],
]);
